module.exports = __webpack_public_path__ + "static/img/Ukrsib.330a567.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/Ukrsib.png
// module id = IRkC
// module chunks = 0